<div class="cmdb-info-container" *ngIf="!isLoadingLabels && !isLoadingImpactMap && !isLoadingFirstTreeDownLevel">
	<div class="cmdb-content-container" [ngClass]="{ 'main-col': mainCol === 'info' }">
		<div class="navigation">
			<a [routerLink]="'/cmdb/list'" *ngIf="impactMapView === 'cmdb'">< {{ labels.lbl_asset_inventario }} </a>
			<a [routerLink]="'/stock'" *ngIf="impactMapView === 'stock'">< {{ labels.lbl_status_estoque }} </a>
		</div>

		<div class="folder-container">
			<div class="tabs-container">
				<span class="tab" [ngClass]="{ selected: tabView === 'ciInfo' }" (click)="tabView = 'ciInfo'">{{
					labels.lbl_geral_informacoes_gerais
				}}</span>
				<span class="tab" [ngClass]="{ selected: tabView === 'logs' }" (click)="tabView = 'logs'">LOG</span>
				<span class="tab" [ngClass]="{ selected: tabView === 'attachment' }" (click)="tabView = 'attachment'">{{
					labels.lbl_geral_anexo
				}}</span>
				<span class="tab" [ngClass]="{ selected: tabView === 'digitalTerm' }" (click)="tabView = 'digitalTerm'">{{
					labels.lbl_termo_digital
				}}</span>
				<span
					class="tab"
					[ngClass]="{ selected: tabView !== 'ciInfo' && tabView !== 'logs' && tabView !== 'attachment' }"
					(click)="tabView = 'plus'"
					><fa-icon [icon]="icons.faPlus"></fa-icon
				></span>
			</div>
			<div class="tab-content-container" [ngClass]="tabView">
				<ng-container *ngIf="tabView === 'ciInfo' && !isLoadingCmdbInfo">
					<div class="button-container">
						<a
							class="button"
							[routerLink]="'/request'"
							[queryParams]="{
								view: 'selfservice',
								idCmdb: selectedCi.data.ciArray[0].cmdb_id
									? selectedCi.data.ciArray[0].cmdb_id
									: selectedCi.data.ciArray[0].id,
							}"
							*ngIf="impactMapView === 'cmdb'"
							>{{ labels.lbl_abrir_chamado }}</a
						>
						<a
							class="button"
							[routerLink]="
								'/cmdb/' +
								selectedCi.data.ciArray[0].type +
								'/' +
								(selectedCi.data.ciArray[0].id ? selectedCi.data.ciArray[0].id : selectedCi.data.ciArray[0].cmdb_id) +
								'/edit'
							"
							*ngIf="canEditCi && impactMapView === 'cmdb'"
							>{{ labels.lbl_geral_editar }}</a
						>
						<div class="button show-smol" (click)="mainCol = 'impact'">{{ labels.lbl_geral_mapa_impacto }}</div>
					</div>

					<div class="mb-3" *ngIf="impactMapView === 'cmdb'">
						<span class="label">Baseline</span>
						<input type="date" (change)="getCiBaseline($event.target.value)" [value]="todayDate" id="baseline" />
					</div>

					<ng-container *ngIf="impactMapView === 'stock'">
						<ng-container
							*ngIf="
								selectedCi.data.ciArray[0].isConsumable == true ||
								selectedCi.data.ciArray[0].isConsumable.toString().toLowerCase() === 'true'
							">
							<div>
								<span class="label">{{ labels.lbl_geral_quan_est }}</span>
								<input [value]="selectedCi.data.ciArray[0].stock.quantityStock" disabled />
							</div>

							<div class="mb-3">
								<span class="label">{{ labels.lbl_status_em_uso }}</span>
								<input [value]="selectedCi.data.ciArray[0].stock.quantityUse" disabled />
							</div>
						</ng-container>
						<ng-container
							*ngIf="
								selectedCi.data.ciArray[0].isConsumable == false ||
								selectedCi.data.ciArray[0].isConsumable.toString().toLowerCase() === 'false'
							">
							<div>
								<span class="label">{{ labels.lbl_usuario_responsavel }}</span>
								<input
									[value]="
										selectedCi.data.ciArray[0].stock.responsible
											? selectedCi.data.ciArray[0].stock.responsible
											: labels.lbl_sem_responsavel
									"
									disabled />
							</div>

							<div>
								<span class="label">{{ labels.lbl_data_prevista_devolucao }}</span>
								<input [value]="selectedCi.data.ciArray[0].stock.expectedReturnDate" disabled />
							</div>

							<div class="mb-3">
								<span class="label">{{ labels.lbl_geral_data_retorno }}</span>
								<input [value]="selectedCi.data.ciArray[0].stock.returnDate" disabled />
							</div>
						</ng-container>
					</ng-container>

					<ng-container *ngFor="let formItem of selectedCiForm; let index = index">
						<div *ngIf="!formItem.hidden && formItem.inputType !== 'textarea' && formItem.inputType !== 'multi-input'">
							<span class="label"
								>{{ labels[formItem.label] ? labels[formItem.label] : formItem.name }}
								<span *ngIf="existInAd && formItem.name === 'host_name'" (click)="getclickAd()"
									><fa-icon [icon]="icons.faInfoCircle" class="existInAd"></fa-icon
								></span>
								<span *ngIf="notExistInAd && formItem.name === 'host_name'" (click)="getclickAd()"
									><fa-icon [icon]="icons.faInfoCircle" class="notExistInAd"></fa-icon
								></span>
							</span>

							<input
								[type]="formItem.inputType"
								[value]="formItem.values[0]"
								(input)="formItem.values[0] = $event.target.value"
								(change)="formItem.values[0] = $event.target.value"
								[disabled]="formItem.disabled" />
						</div>

						<ng-container *ngIf="!formItem.hidden && formItem.inputType === 'multi-input'">
							<div>
								<span>{{ labels[formItem.label] ? labels[formItem.label] : formItem.name }}</span>
							</div>
							<div class="mb-3">
								<textarea
									[rows]="3"
									[value]="
										formItem.values[0]
											.toString()
											.replaceAll(',', '\n')
											.replaceAll('[', '')
											.replaceAll(']', '')
											.replaceAll('§', ', ')
									"
									[disabled]="formItem.disabled">
								</textarea>
							</div>
						</ng-container>

						<ng-container *ngIf="!formItem.hidden && formItem.inputType === 'textarea'">
							<div>
								<span>{{ labels[formItem.label] ? labels[formItem.label] : formItem.name }}</span>
							</div>
							<div class="mb-3">
								<textarea [rows]="4" [value]="selectedCi.data.ciArray[0].notes" [disabled]="formItem.disabled"></textarea>
							</div>
						</ng-container>
					</ng-container>

					<div class="button-container">
						<a
							class="button"
							[routerLink]="
								'/cmdb/' +
								selectedCi.data.ciArray[0].type +
								'/' +
								(selectedCi.data.ciArray[0].id ? selectedCi.data.ciArray[0].id : selectedCi.data.ciArray[0].cmdb_id) +
								'/edit'
							"
							*ngIf="canEditCi && impactMapView === 'cmdb'"
							>{{ labels.lbl_geral_editar }}</a
						>
					</div>
				</ng-container>

				<ng-container *ngIf="tabView === 'logs' && !isLoadingCmdbInfo">
					<div class="log" *ngIf="!ciLogs || ciLogs.length === 0">
						{{ labels.lbl_cmdb_nenhum_log }}
					</div>

					<div class="log" *ngFor="let log of ciLogs; let index = index">
						<div class="log-date" [title]="'BASELINE'">
							<span
								[ngClass]="{ link: index != ciLogs.length - 1 && impactMapView === 'cmdb' }"
								(click)="(impactMapView === 'cmdb' ? log.log_date : null)"
								>{{ DateService.formatDate(log.log_date) }}</span
							>
							<span> - {{ log.status }}</span>
						</div>
						<span class="log-date">{{ log.analyst }}</span>
						<span class="log-notes" [innerHTML]="log.notes"></span>
					</div>
				</ng-container>

				<ng-container *ngIf="tabView === 'attachment' && !isLoadingCmdbInfo">
					<div class="file" *ngFor="let file of ciAttachments; let index = index">
						<div>
							<span>{{ file.name }}</span>
							<div class="button-container">
								<span class="file-button" (click)="downloadFile(index)"><fa-icon [icon]="icons.faDownload"></fa-icon></span>
							</div>
						</div>
					</div>

					<div class="file" *ngIf="ciAttachments.length === 0">
						{{ labels.lbl_security_nenhum_registro }}
					</div>
				</ng-container>

				<ng-container *ngIf="tabView === 'digitalTerm' && !isLoadingCmdbInfo">
					<div class="log" *ngIf="!cmdbDigitalTermPayload">
						{{ labels.lbl_nao_existem_logs_termos_digitais }}
					</div>

					<div class="log" *ngFor="let term of cmdbDigitalTermPayload; let index = index">
						<span class="log-date"> {{ DateService.formatDate(term.generation_date) }} - {{ term.term_type }} </span>
						<span class="log-date">{{ term.user }}</span>

						<span class="log-notes">
							<b>{{ labels.lbl_checklist }}:</b> {{ term.checklist === '1' ? labels.lbl_geral_sim : labels.lbl_cmdb_nao
							}}<br />
							<b>{{ labels.lbl_gerar_e_enviar }}:</b>
							{{ term.generate_send === '1' ? labels.lbl_geral_sim : labels.lbl_cmdb_nao }}<br />
							<b>{{ labels.lbl_usuario_terceiro }}:</b>
							{{ term.third_party_user === '1' ? labels.lbl_geral_sim : labels.lbl_cmdb_nao }}<br />
							<b>{{ labels.lbl_usuario_desligado }}:</b>
							{{ term.user_disconnected === '1' ? labels.lbl_geral_sim : labels.lbl_cmdb_nao }}<br />
							<b>{{ labels.lbl_devolucao_troca_equipamento }}:</b>
							{{ term.return_or_exchange_equipment === '1' ? labels.lbl_geral_sim : labels.lbl_cmdb_nao }}<br />

							<b>{{ labels.lbl_tipo_de_termo }}:</b> {{ term.term_type }}<br />
							<b>{{ labels.lbl_asset_numero_serie }}:</b> {{ term.serial_number }}<br />
							<!-- <b>UUID:</b> {{ term.uuid }}<br> -->
							<b>{{ labels.lbl_assinatura_digital }}:</b> {{ term.signature || 'N/A' }}<br />
						</span>
						<div *ngIf="term.signature" class="button-container">
							<span>{{ term.file.name }}</span>
							<span class="file-button" (click)="downloadDigitalTerm(term.file)"
								><fa-icon [icon]="icons.faDownload"></fa-icon
							></span>
						</div>
					</div>
				</ng-container>

				<ng-container *ngIf="tabView === 'relationship' && !isLoadingCmdbInfo">
					<ng-container *ngIf="relationshipNode && relationshipNode.parent.data">
						<span class="mb-1">{{ labels.lbl_geral_responsavel }}</span>
						<div class="log">
							{{ relationshipNode.parent.data.name }}
						</div>
					</ng-container>

					<ng-container *ngIf="relationshipNode && relationshipNode.children && relationshipNode.children.length > 0">
						<span class="mb-1 mt-2">{{ labels.lbl_geral_dependente }}</span>
						<div class="log" *ngFor="let child of relationshipNode.children">
							{{ child.data.name }}
						</div>
					</ng-container>
				</ng-container>

				<ng-container *ngIf="tabView === 'status' && !isLoadingCmdbInfo">
					<span class="mb-1 mt-2">{{ labels.lbl_edocs_atualizacao_status }}</span>
					<div class="log" *ngIf="!statusCiLogs || statusCiLogs.length === 0">
						{{ labels.lbl_cmdb_nenhum_log }}
					</div>

					<div class="log" *ngFor="let status of statusCiLogs">
						<span class="log-date">{{ DateService.formatDate(status.log_date) }}</span>
						<span class="log-date">{{ status.analyst }}</span>
						{{ status.notes }}
					</div>
				</ng-container>

				<ng-container *ngIf="tabView === 'plus' && !isLoadingCmdbInfo">
					<div class="button" (click)="tabView = 'relationship'">{{ labels.lbl_cmdb_relacionamento }}</div>
					<div class="button" (click)="tabView = 'status'">{{ labels.lbl_geral_status }}</div>
				</ng-container>

				<ng-container *ngIf="isLoadingCmdbInfo">
					<cpi-dot-bounce-loading-effect [color]="'var(--gray-5)'"></cpi-dot-bounce-loading-effect>
				</ng-container>
			</div>
		</div>
	</div>

	<div
		class="impact-map-container"
		[ngClass]="{ 'main-col': mainCol === 'impact', 'loading-relationship': isLoadingCiParents || isLoadingCiChildrens }"
		(wheel)="onScroll($event)"
		(mousedown)="mouseDownImpactMap($event)"
		(mouseup)="mouseUpImpactMap()"
		(mousemove)="confirmMouseMoveImpactMap()"
		id="impactMapContainer">
		<p-organizationChart
			[ngClass]="{ 'mouse-down': impactMapPos.mouseDown && impactMapPos.mouseMove }"
			[ngStyle]="{
				transform:
					'matrix(' +
					impactMapPos.zoomLevel +
					', 0, 0,' +
					impactMapPos.zoomLevel +
					',' +
					impactMapPos.x +
					',' +
					impactMapPos.y +
					')',
			}"
			[(value)]="impactMapData"
			selectionMode="single"
			[selection]="selectedCi"
			(onNodeSelect)="onNodeSelect($event.node)"
			id="impactMapChart">
			<ng-template let-node pTemplate="default">
				<div class="impact-node-container" id="impactNodeContainer">
					<div class="header">
						<span class="ci-name" *ngIf="node.data.ciArray[0].identification" [title]="node.data.ciArray[0].identification">
							{{ node.data.ciArray[0].identification }}
						</span>
						<span class="ci-status" [ngClass]="node.data.ciArray[0].status"></span>
					</div>
					<div *ngIf="impactMapView === 'cmdb'">{{ labels.lbl_geral_status }}: {{ node.data.ciArray[0].status }}</div>
					<div
						class="node-body-grid"
						[ngClass]="{
							'node-sp-2': node.data.ciArray[0].stock.isConsumable != true && !node.data.ciArray[0].stock.responsible,
						}"
						*ngIf="impactMapView === 'stock'">
						<ng-container *ngIf="node.data.ciArray[0].stock.isConsumable == true">
							<span>{{ labels.lbl_geral_quan_est }}:</span> <span>{{ node.data.ciArray[0].stock.quantityStock }}</span>
							<span>{{ labels.lbl_status_em_uso }}:</span> <span>{{ node.data.ciArray[0].stock.quantityUse }}</span>
						</ng-container>

						<ng-container *ngIf="node.data.ciArray[0].stock.isConsumable != true">
							<ng-container *ngIf="node.data.ciArray[0].stock.responsible">
								<span>{{ labels.lbl_usuario_responsavel }}:</span> <span>{{ node.data.ciArray[0].stock.responsible }}</span>
								<span>{{ labels.lbl_data_prevista_devolucao }}:</span>
								<span>{{ node.data.ciArray[0].stock.expectedReturnDate }}</span>
								<span>{{ labels.lbl_geral_data_retorno }}:</span> <span>{{ node.data.ciArray[0].stock.returnDate }}</span>
							</ng-container>
							<ng-container *ngIf="!node.data.ciArray[0].stock.responsible">
								<span>{{ labels.lbl_sem_responsavel }}</span>
							</ng-container>
						</ng-container>
					</div>
					<div class="node-extra-button-container">
						<div class="node-extra-button top" (click)="expandCiTreeDown($event, node)" *ngIf="node.data.isLeaf">
							<fa-icon [icon]="icons.faSortDown"></fa-icon>
						</div>
						<div class="node-extra-button bottom" (click)="expandCiTreeUp($event, node)" *ngIf="node.data.isRoot">
							<fa-icon [icon]="icons.faSortUp"></fa-icon>
						</div>
					</div>
				</div>
			</ng-template>
		</p-organizationChart>

		<div class="impact-map-button-container">
			<div class="ball" [ngClass]="{ disabled: impactMapPos.zoomLevel == 3 }" (click)="zoomIn()">
				<fa-icon [icon]="icons.faMagnifyingGlassPlus"></fa-icon>
			</div>
			<div class="ball" [ngClass]="{ disabled: impactMapPos.zoomLevel == 0.5 }" (click)="zoomOut()">
				<fa-icon [icon]="icons.faMagnifyingGlassMinus"></fa-icon>
			</div>
			<div class="ball" (click)="impactMapPos.x = 0; impactMapPos.y = 0"><fa-icon [icon]="icons.faArrowsToDot"></fa-icon></div>
		</div>

		<div class="button back-button" [ngClass]="{ 'show-smol': mainCol === 'impact' }" (click)="mainCol = 'info'">
			{{ labels.lbl_geral_voltar }}
		</div>

		<div
			class="impact-map-plastic-wrap"
			(mouseup)="mouseUpImpactMap()"
			(mouseout)="mouseUpImpactMap()"
			(mousemove)="moveImpactMap($event)"
			*ngIf="impactMapPos.mouseDown === true && impactMapPos.mouseMove === true"></div>
	</div>
</div>

<div class="loading-container" *ngIf="isLoadingImpactMap || isLoadingLabels || isLoadingFirstTreeDownLevel">
	<cpi-svg-gears [gearSpinDurationMS]="10000"></cpi-svg-gears>
	<div>{{ labels.lbl_edocs_carregando }}!</div>
</div>
